import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import orderRunnerService from "services/orderRunnerService";

export const useListOrderRunner = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  const { params, runnerId } = payload;

  return useQuery(
    [
      "order-runner",
      runnerId,
      params?.page,
      params?.columnFilter,
      params?.keywords,
      params?.run,
    ],
    () => orderRunnerService.listOrderRunner(payload),
    {
      enabled: !!runnerId && params?.run,
      refetchOnWindowFocus: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("order_runner"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};
